import { Api } from "../config/request";

export default {
  bulkUploadLeads(payload) {
    return Api.post("/bulk-upload/leads", payload, null, null, "formData");
  },
};
